import React from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { teams } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import DateSelector from '../DateSelector';
import MultiSelectPrimary from '../MultiSelectPrimary';
import CustomTimePicker from '../CustomTimePicker';
import { useSelector } from 'react-redux';
import GroundSelectAutocomplete from '../GroundSelectAutocomplete';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const TrainingScheduleTable = (props: any) => {
  const { manageChange } = props;

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');
  const trainingSchedule = useSelector((state:any) => state.dataCaptures.selectedTeam)?.trainingSchedule;
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      trainingSchedule?.length > 0 &&
      stableSort(trainingSchedule, getComparator(order, orderBy)),
    [order, orderBy, trainingSchedule],
  );

  const days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  const daysKeys = ['mon', 'tue', 'wed', 'thur', 'fri', 'sat', 'sun'];

  const head = [
    {key: '', displayName: 'Day'},
    {key: '', displayName: 'Start'},
    {key: '', displayName: 'End'},
    {key: '', displayName: 'Ground'},
    {key: '', displayName: 'Remarks'},
  ]

  const updateSchedule = (mainKey: any, key: any, updatedValue: any) => {
        const updatedSchedule = {
            ...trainingSchedule,
            [mainKey]: {
                ...trainingSchedule[mainKey],
                [key]: updatedValue,
            },
        };
        manageChange(updatedSchedule);
  }


  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                    <TableBody>
                    {
                        trainingSchedule && Object.keys(trainingSchedule).length > 0 &&
                        daysKeys?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-${i}`}
                        >
                            <TableCell className='fs12'>
                              {days[i]}
                            </TableCell>
                            <TableCell className='fs12'>
                                <CustomTimePicker
                                format={'HH:mm'}
                                views={['hours', 'minutes']}
                                manageChange={(e:any) => {updateSchedule(d, 'start', e)}}
                                value={(trainingSchedule[d]?.start) ? new Date(trainingSchedule[d]?.start) : ''}
                                isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell className='fs12'>
                                <CustomTimePicker
                                format={'HH:mm'}
                                views={['hours', 'minutes']}
                                manageChange={(e:any) => {updateSchedule(d, 'end', e)}}
                                value={(trainingSchedule[d]?.end) ? new Date(trainingSchedule[d]?.end) : ''}
                                isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <GroundSelectAutocomplete 
                              selectedValues={trainingSchedule[d]?.grounds ? trainingSchedule[d]?.grounds : []}
                              manageSelect={(e:any) => { updateSchedule(d, 'grounds', e) }}
                              label={''}
                              variant={'standard'}
                              isReadOnly={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <TextField 
                              variant='standard' 
                              sx={{ width: '100%' }} 
                              value={trainingSchedule[d]?.remarks} 
                              onChange={(e:any) => { updateSchedule(d, 'remarks', e.target.value) }}
                              disabled={isAdmin} />
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default TrainingScheduleTable;